import { initializeApp } from 'firebase/app';
import { Environment } from './environment';

const devConfig = {
  apiKey: 'AIzaSyArhp8WG7E1mU2NfMvgF-RmN2N_ir_OgDw',
  authDomain: 'assetflow-dev-f6fa5.firebaseapp.com',
  projectId: 'assetflow-dev-f6fa5',
  storageBucket: 'assetflow-dev-f6fa5.firebasestorage.app',
  messagingSenderId: '918441415846',
  appId: '1:918441415846:web:dc99a978069296281f1067',
};

const prodConfig = {
  apiKey: 'AIzaSyC6P89lBU0s7rJhLPfo5yUN0vgFWA7nz1w',
  authDomain: 'assetflow-backend-2024.firebaseapp.com',
  projectId: 'assetflow-backend-2024',
  storageBucket: 'assetflow-backend-2024.firebasestorage.app',
  messagingSenderId: '886916337407',
  appId: '1:886916337407:web:785053f308814ba2cf06ca',
};

export const app = initializeApp(
  Environment.isProd ? prodConfig : devConfig,
);

if (Environment.isProd) {
  const actualProject = app.options.projectId;
  if (actualProject !== 'assetflow-backend-2024') {
    throw new Error(
      `FATAL: Project mismatch. Expected assetflow-backend-2024, got ${actualProject}`,
    );
  }
}
